import React, { useContext } from "react";
import { TextField, Box, Link as MuiLink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import NonIconButton from "../../../../components/NonIconButton";
import { recruitmentRegistrationContext } from "../../RecruitmentRegistationPage";
import {
  BigHeadline,
  NormalText,
  SmallHeadline,
  SmallText,
} from "../../../../components/TextParts";
import ProjectTypeField from "../molecules/ProjectTypeField";
import RequiredSkill from "../molecules/RequiredSkill";

export default function RegistationComponent() {
  const {
    defaultMailSubject,
    defaultMailBody,
    setIsModalOpen,
    mailBody,
    setMailBody,
    mailSubject,
    setMailSubject,
    projectType,
    requiredSkill,
  } = useContext(recruitmentRegistrationContext);

  const isNextDisabled =
    defaultMailSubject === mailSubject ||
    defaultMailBody === mailBody ||
    projectType === null ||
    !requiredSkill;

  return (
    <Box>
      <BigHeadline text="募集登録" sx={{ mb: { xs: "10px", sm: "30px" } }} />

      <SmallHeadline
        text="件名"
        sx={{ mt: 0, mb: { xs: "10px", sm: "20px" } }}
      />
      <TextField
        id="mailSubject"
        multiline
        rows={2}
        sx={{ backgroundColor: "white" }}
        fullWidth
        value={mailSubject}
        inputProps={{ maxLength: 255, "aria-label": "subject" }}
        onChange={(e) => setMailSubject(e.target.value)}
      />

      <Box sx={{ display: "flex" }}>
        <SmallHeadline text="募集種別" />
        <NormalText
          text="※選択必須項目です。"
          sx={{ mt: "34px", ml: "20px" }}
        />
      </Box>
      <ProjectTypeField />

      <RequiredSkill />

      <Box sx={{ display: "flex" }}>
        <SmallHeadline text="本文" sx={{ mb: { xs: "10px", sm: "20px" } }} />
        <Box sx={{ pt: "30px", pl: "20px" }}>
          <MuiLink
            component={RouterLink}
            to="/recruitmentRegister/sample"
            target="_blank"
            rel="noopener noreferrer"
          >
            サンプルはこちら
          </MuiLink>
        </Box>
      </Box>

      <Box sx={{ pb: "10px" }}>
        <SmallText text="フォーマットに則って各項目に入力いただくか、貴社の案件フォーマットがございましたら、上書きしてください。" />
      </Box>

      <TextField
        id="mailBody"
        value={mailBody}
        multiline
        rows={16}
        sx={{ backgroundColor: "white" }}
        fullWidth
        inputProps={{ maxLength: 2048, "aria-label": "mailBody" }}
        onChange={(e) => setMailBody(e.target.value)}
      />

      <Box
        sx={{
          display: "flex",
          width: "200px",
          ml: "auto",
          justifyContent: "flex-end",
        }}
      >
        <NormalText text={`${mailBody?.length || 0}`} />
        <NormalText text="/2048" />
      </Box>

      <Box sx={{ width: { xs: "160px", sm: "400px" }, mx: "auto", mt: "40px" }}>
        <NonIconButton
          title="次へ"
          clickEvent={() => setIsModalOpen(true)}
          disabled={isNextDisabled}
        />
      </Box>
    </Box>
  );
}